import { Default, Detail, List } from "./views";
import { ApplyAction } from "./wizards";

const Module = {
    name: "synchronizableleads",
    defaultRoutePath: "/synchronizableleads/deliveryqlik",
    menuItemScope: "synchronizable",
    menuItemName: "deliveryQliks",
    routes: [{
        path: "/synchronizableleads/deliveryqlik",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "applyAction",
            Component: ApplyAction,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        // {
        //     path: "create",
        //     Component: Create,
        // },
    ],
    
}

export default Module;
